import type { ImgHTMLAttributes } from 'react';
import { rutaDeLogo, type VarianteDeLogo } from './aplicar';
import { useBranding } from './useBranding';

interface Props extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  /** `login` deja que el branding elija (Atlas muestra el isotipo; WE ARE, el wordmark). */
  variante: VarianteDeLogo | 'login';
  /**
   * El lockup horizontal de la sidebar expandida va con el alto que pide cada branding
   * (`logos.altoHorizontalEnSidebar`): cada logo tiene su proporción y un alto fijo en la
   * clase dejaría al de WE ARE de 32 px de ancho.
   */
  altoDeSidebar?: boolean;
}

/** El logo del branding activo. Reemplaza a los `<img src="/images/estudio-atlas-logo-*.svg">`. */
export function LogoDeMarca({ variante, alt, draggable = false, altoDeSidebar, style, ...resto }: Props) {
  const b = useBranding();
  const resuelta = variante === 'login' ? b.logos.login : variante;
  const estilo = altoDeSidebar ? { ...style, height: b.logos.altoHorizontalEnSidebar } : style;
  return (
    <img
      src={rutaDeLogo(b.logos, resuelta)}
      alt={alt ?? b.nombre}
      draggable={draggable}
      style={estilo}
      {...resto}
    />
  );
}
